import angular from 'angular';
import uiRouter from 'angular-ui-router';
import SubCaseComponent from './newSubCase.component';
import routing from './newSubCase.routes';

export default angular
  .module('verifyApp.cases.newSubCase', [uiRouter])
  .config(routing)
  .component('newSubCase', SubCaseComponent)
  .name;



// WEBPACK FOOTER //
// ./client/app/cases/newSubCase/index.js